<template>
  <b-card class="mt-5" style="min-width: 340px; max-width: 480px; margin: auto; justify-self: center">
    <div class="brand-logo" />
    <h2>Inicio de sesión</h2>
    <b-form @submit.prevent="iniciarSesion">
      <b-form-group label="Email">
        <b-form-input
          v-model="email"
          required
          autofocus
          autocomplete="username"
          type="email"
          placeholder="Email del usuario"
        />
      </b-form-group>
      <b-form-group label="Contraseña">
        <b-form-input v-model="clave" type="password" autocomplete="current-password" placeholder="Contraseña" />
      </b-form-group>
      <b-button type="submit" variant="primary" class="mt-2"> Acceder </b-button>
    </b-form>
  </b-card>
</template>

<script>
import { useSessionStore } from "@/stores/SessionStore";

export default {
  data() {
    return {
      email: "",
      clave: "",
    };
  },
  async mounted() {
    const sessionStore = useSessionStore();
    try {
      await sessionStore.recover();
      this.$router.push({ path: this.$route.query.redirect || "/" });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("No se puede recuperar la sesión. Lo que es normal si no hay sesión iniciada");
    }
  },
  methods: {
    async iniciarSesion() {
      const sessionStore = useSessionStore();
      await sessionStore.login(this.email, this.clave);
      this.$router.push("/");
    },
  },
};
</script>
